import FormattedMessageWithObjectTypeName from 'automation-ui-i18n/FormattedMessageWithObjectTypeName';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ABTestBranchActionSummary({
  flowObjectTypeId,
  numOfBranches
}) {
  return /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
    baseLangKey: "automation-ui-action-features.action-features.ab-test-branch.summary_cob",
    objectTypeId: flowObjectTypeId,
    options: {
      numOfBranches
    }
  });
}